








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteOriginStory, QueryOriginStoryList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditOriginStoryDialog from './EditOriginStoryDialog.vue'

@Component({
  components: { VQuery, VTable, EditOriginStoryDialog },
})
export default class OriginStoryList extends Vue {
  private queryParam = { startRow: 1, limit: 10, title: '' }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [{ title: '标题', param: 'title' }]
  private queryOperation: Array<TableOperation> = [{ title: '新建', type: 'primary', click: this.openCreate }]
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '封面', param: 'coverUrl', type: 'image' },
    { title: '标题', param: 'title' },
    { title: '首页展示', param: 'isHomepage', formatter: (v: number) => (v === 1 ? '是' : '否') },
    { title: '状态', param: 'status', formatter: (v: number) => (v === 1 ? '启用' : '停用') },
    { title: '排序', param: 'sort' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat, width: 160 },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEdit },
        { title: '删除', click: this.deleteRow },
      ],
    },
  ]

  public created() {
    this.loadData()
  }

  private openCreate() {
    const d = this.$refs.EditOriginStoryDialog as EditOriginStoryDialog
    d.open({}, false)
  }

  private openEdit(row: any) {
    const d = this.$refs.EditOriginStoryDialog as EditOriginStoryDialog
    d.open(row, true)
  }

  private deleteRow(row: any) {
    MessageBox.confirm('确定删除？', '提示', { type: 'warning' }).then(async () => {
      await DeleteOriginStory({ id: row.id })
      Message.success('删除成功')
      this.loadData()
    })
  }

  private async loadData() {
    const param: any = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    const result = await QueryOriginStoryList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  private pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  private sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
